import { IconLoading } from '@myrealtrip/web-ui';

import * as styles from './Fallback.style';

interface PropsType {
  className?: string;
}

function Fallback({ className = '' }: PropsType) {
  return <IconLoading isFullScreen className={className} css={styles.loading} />;
}

export default Fallback;
